import * as api from './api';
import { Setting, Request } from '../';
import { sleep } from '@yichui/js-contrib/src/utils';

// 防并发请求
let doing_init = false; // true:正在初始化
let doing_user = false; //

//
const state = {
  walletUser: {}, // 模块用户信息
  walletAllow: [],
  walletList: [],
  walletMap: {},
};

//
const mutations = {
  updateState(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {
      state[key] = payload[key];
    });
  },
  SET_WALLET_USER: (state, data) => {
    state.walletUser = Object.assign({}, data);
  },
  SET_WALLET_ALLOW: (state, data) => {
    state.walletAllow = [...data];
  },
  SET_WALLET_LIST: (state, data) => {
    state.walletList = [...data];
    state.walletMap = {};
    state.walletList.forEach(v => {
      state.walletMap[v.category] = v;
    });
  },
};

//
const actions = {
  // 我的信息
  async walletUser({ state, commit }, params) {
    if (doing_user) {
      // 并发等结果
      while (doing_user) {
        await sleep(50);
      }
    } else {
      //
      try {
        doing_user = true;
        //
        const data = await api.walletUser(params);
        // console.log('walletUser', data);
        if (data) {
          commit('SET_WALLET_USER', data);
        }
      } catch (err) {
        // 未知错误
        console.error(`walletUser`, err);
        commit('SET_WALLET_USER', {});
      } finally {
        doing_user = false;
      }
    }
    return state.walletUser;
  },
  // 钱包类型枚举
  async walletAllow({ state, commit }, params) {
    if (doing_init) {
      // 并发等结果
      while (doing_init) {
        await sleep(50);
      }
    } else {
      //
      try {
        doing_init = true;
        //
        const data = await api.walletAllow(params);
        // console.log('walletAllow', data);
        if (data) {
          commit('SET_WALLET_ALLOW', data);
        }
      } catch (err) {
        // 未知错误
        console.log(err);
        commit('SET_WALLET_ALLOW', []);
      } finally {
        doing_init = false;
      }
    }
    return state.walletAllow;
  },
  // 我的所有钱包
  async walletList({ state, commit, dispatch }, params = {}) {
    if (state.walletAllow.length === 0) {
      await dispatch('walletAllow');
    }
    if (state.walletAllow.length > 0) {
      try {
        params['walletAllow'] = [...state.walletAllow];
        const data = await api.walletList(params);
        // console.log('walletList', data);
        commit('SET_WALLET_LIST', data);
      } catch (err) {
        commit('SET_WALLET_LIST', []);
      }
    }
    return [...state.walletList];
  },
};

//
const getters = {};

//
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
